import React from 'react';
import { useParams } from '../../../../../../services/routing/useRouteInfo';
import { ReactComponent as SmsIcon } from '../../../../../../assets/icons/sms.svg';
import { ViewLayout } from '../../../../../shared/cardLayouts/viewLayout';
import { AutoSizeCard } from '../../../../../shared/cards/autoSizeCard';
import { IconHeading } from '../../../../../shared/cards/iconHeading';
import { StatCard } from '../../../../../shared/cards/statCard';
import { LoadText } from '../../../../../shared/load/loadText';
import { View } from '../../../../../shared/view/view';

import styles from './campaignAdhocTemplateView.module.css';
import { pathJoin } from '../../../../../../services/api';
import { NoteCard } from '../../../../../shared/cards/noteCard';
import { Edit } from '../../../../../shared/actions/actionButtons';
import { IsActiveCard } from '../../../../../shared/cards/isActiveCard';
import { CAMPAIGN_ADHOC_TEMPLATE } from '../../../../../../permissions';


export const CampaignAdhocTemplateView = () => {

    let { id } = useParams();
    return <View
        id={parseInt(id ?? '')}
        resourceName='Campaign Template'
        nameFunction={r => r?.name}
        restEndpoint='/communications/campaigns/adhocs/templates'
        listUrl='/communications/campaigns/templates'
        readPermissions={[CAMPAIGN_ADHOC_TEMPLATE.READ]}
        writePermissions={[CAMPAIGN_ADHOC_TEMPLATE.WRITE]}
        actions={[Edit]}
    >
        {
            ({ loading, data, canWrite, canRead, refreshData }) => <ViewLayout>
                {data.note ? <NoteCard
                    columns={3}
                    restEndpoint={pathJoin('communications', 'campaigns', 'adhocs', 'templates', id)}
                    refreshData={refreshData}
                    title='Template Note'
                    editButton={canWrite}
                    deleteButton={canWrite}
                >{data.note}</NoteCard> : ''}

                <StatCard
                    title={<>Campaign Template Info</>}
                    stats={{
                        'Name': loading ? <LoadText /> : data.name ?? 'None',
                        'Outbound Contact': loading ? <LoadText /> : (data.outboundCallerId && data.outboundCallerId.name + ' ' + data.outboundCallerId.contact) ?? 'None',
                        'Channel': loading ? <LoadText /> : data.outboundCallerId?.channel?.displayName ?? 'None',
                    }}
                />

                <AutoSizeCard
                    columns={2}
                >
                    <IconHeading icon={<SmsIcon />} iconBackground={false}>
                        Message
                    </IconHeading>
                    <div className={styles.Message}>{loading ? <><LoadText /><br /><LoadText /><br /><LoadText /></> : data.message}</div>
                </AutoSizeCard>

                <IsActiveCard
                    active={data.active}
                    loading={loading}
                />
            </ViewLayout>
        }
    </View>
}